import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export const faro = process.env.REACT_APP_FARO_URL
  ? initializeFaro({
      url: process.env.REACT_APP_FARO_URL,
      app: {
        name: 'novamarket-react',
        version: process.env.REACT_APP_VERSION || '1.0.0',
        environment: process.env.NODE_ENV,
      },
      instrumentations: [
        ...getWebInstrumentations(),
        new TracingInstrumentation(),
      ],
    })
  : null;

const recordRouteChange = ({ pathname, search }) => {
  faro?.api.pushEvent('route_change', { path: `${pathname}${search}` });
};

recordRouteChange(history.location);
history.listen(recordRouteChange);
